import { useState } from 'react';

// src/InvoiceTaxPanel.js
const InvoiceTaxPanel = ({
  states,
  selectedStateAbbr,
  salesTaxRate,
  selectedLocalTaxIds,
  disabled,
  onSalesTaxChange,
  onLocalTaxSelectionChange,
  onStateChange,
  inputStyle,
  neonLabelStyle,
}) => {
  const [isLocalSelectorOpen, setIsLocalSelectorOpen] = useState(false);
  const stateList = Array.isArray(states) ? states : [];
  const homeState = stateList.find(s => s.is_home_state) || stateList[0] || null;
  const effectiveAbbr = selectedStateAbbr || (homeState ? homeState.state_abbr : '');
  const selectedState = stateList.find(s => s.state_abbr === effectiveAbbr) || null;
  const filteredCounties = selectedState ? (Array.isArray(selectedState.counties) ? selectedState.counties : []) : [];
  const selectedIdSet = new Set(
    Array.isArray(selectedLocalTaxIds) ? selectedLocalTaxIds.map(id => String(id)) : []
  );
  const selectedRecords = filteredCounties.filter(county => selectedIdSet.has(String(county.id)));
  const selectedSummary = selectedRecords.length === 0
    ? 'SELECT COUNTY / LOCAL / OTHER'
    : selectedRecords.length === 1
      ? String(selectedRecords[0].name || '').toUpperCase()
      : `${String(selectedRecords[0].name || '').toUpperCase()} + ${selectedRecords.length - 1} MORE`;

  const handleLocalTaxToggle = (localTax, checked) => {
    const nextSelectedIds = new Set(selectedIdSet);
    const localTaxId = String(localTax.id);

    if (checked) nextSelectedIds.add(localTaxId);
    else nextSelectedIds.delete(localTaxId);

    onLocalTaxSelectionChange(
      filteredCounties.filter(county => nextSelectedIds.has(String(county.id)))
    );
  };

  return (
    <>
      <div>
        <label style={neonLabelStyle}>STATE</label>
        <select
          style={inputStyle}
          value={effectiveAbbr}
          disabled={disabled || stateList.length === 0}
          onChange={e => {
            const abbr = e.target.value;
            const st = stateList.find(s => s.state_abbr === abbr);
            if (!st) return;
            const defCounty = (st.counties || []).find(c => c.is_default);
            onStateChange(
              st.state_abbr,
              st.state_name,
              Number(st.state_sales_tax_rate || 0),
              defCounty ? Number(defCounty.rate || 0) : 0,
              defCounty ? defCounty.name : ''
            );
          }}
        >
          {stateList.length === 0 ? (
            <option value="">NO STATES CONFIGURED</option>
          ) : (
            <>
              <option value="">SELECT STATE</option>
              {stateList.map(s => (
                <option key={s.state_abbr || String(s.id)} value={s.state_abbr}>
                  {s.state_name}{s.is_home_state ? ' (HOME)' : ''}
                </option>
              ))}
            </>
          )}
        </select>
      </div>

      <div>
        <label style={neonLabelStyle}>STATE TAX %</label>
        <input
          style={inputStyle}
          type="number"
          value={salesTaxRate}
          disabled={disabled}
          onChange={e => onSalesTaxChange(e.target.value)}
          placeholder="STATE TAX %"
        />
      </div>

      <div>
        <label style={neonLabelStyle}>COUNTY / LOCAL / OTHER — SELECT</label>
        <button
          type="button"
          style={{
            ...inputStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
            textAlign: 'left',
            cursor: disabled ? 'not-allowed' : 'pointer'
          }}
          disabled={disabled}
          aria-expanded={isLocalSelectorOpen}
          onClick={() => setIsLocalSelectorOpen(open => !open)}
        >
          <span>{selectedSummary}</span>
          <span aria-hidden="true">{isLocalSelectorOpen ? '▲' : '▼'}</span>
        </button>

        {isLocalSelectorOpen && (
          <div style={{ border: '4px solid black', borderTop: 0, backgroundColor: 'white' }}>
            {filteredCounties.length === 0 ? (
              <div style={{ padding: '12px', color: 'black', fontWeight: 900 }}>
                NO COUNTY / LOCAL / OTHER TAXES CONFIGURED
              </div>
            ) : (
              filteredCounties.map(localTax => (
                <label
                  key={localTax.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '12px',
                    borderTop: '2px solid black',
                    color: 'black',
                    fontWeight: 900,
                    cursor: disabled ? 'not-allowed' : 'pointer'
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedIdSet.has(String(localTax.id))}
                    disabled={disabled}
                    onChange={event => handleLocalTaxToggle(localTax, event.target.checked)}
                  />
                  <span>{localTax.name} ({Number(localTax.rate || 0)}%)</span>
                </label>
              ))
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default InvoiceTaxPanel;
